// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/quick-order/quick-order.less
// module id = 3606
// module chunks = 0